<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section id="file-upload">
            <div class="card">
                <div class="card-body px-0" *ngIf="_utilsService.isDesktop || _utilsService.isTablet">
                    <div class="row" id="page-payroll">
                        <div class="px-3 col-lg-4 col-12">
                            <h3>{{'ENTER_MULTI_FILE' | translate}}</h3>
                            <small>{{'LAST_UPLOAD'| translate}}: {{this._utilsService.formatDate(this._utilsService.themeConfiguration.last_payroll_update, 'DD/MM/YYYY HH:mm')}}</small>
                            <div id="file-uploader" class="custom-file mt-1">
                                <input class="custom-file-input" type="file" lang="it" id="file" multiple="true" (change)="addFileToList($any($event).target.files)" accept="application/pdf"/>
                                <label class="custom-file-label">{{"SELECT_FILE" | translate}}</label>
                            </div>
                        </div>

                        <ngb-alert [type]="'danger'" [dismissible]="false" class="card mx-3 mt-3 w-100 m-0" [ngClass]="active_table==='danger1' ? 'active' : ''" *ngIf="fiscalCodesNotFounded.length > 0">
                            <h4 class="alert-heading py-1" (click)="changeTab('danger1')">
                               {{'LIST_PAYROLL_NOT_FOUNDED' | translate}}
                            </h4>
                            <section class="px-1" [ngClass]="active_table==='danger1' ? 'alert-body' : ''">
                                <p>{{'FISCALCODES_NOT_MATCHED' | translate}}</p>
                                <ul>
                                    <li *ngFor="let fc of fiscalCodesNotFounded">{{fc}}</li>
                                </ul>
                            </section>
                        </ngb-alert>

                        <ngb-alert [type]="'danger'" [dismissible]="false"  class="card mx-3 mt-3 w-100 m-0" [ngClass]="active_table==='danger2' ? 'active' : ''" *ngIf="uploadErrors.length > 0">
                            <h4 class="alert-heading py-1" (click)="changeTab('danger2')">
                                {{'PAYROLL_UPLOAD_ERRORS_TITLE' | translate}}
                            </h4>
                            <section class="px-1" [ngClass]="active_table==='danger2' ? 'alert-body' : ''">
                                <p>{{'PAYROLL_UPLOAD_ERRORS_DESCRIPTION' | translate}}</p>
                                <ul>
                                    <li *ngFor="let fc of uploadErrors">{{fc.filename}}: {{fc.error | translate}}</li>
                                </ul>
                            </section>
                        </ngb-alert>

                        <div class="col-12 mt-3 px-3">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h3 class="mb-0">{{'PAYROLL_TO_UPLOAD_LIST' | translate}}</h3>
                                </div>
                                <div *ngIf="files_list_obj.length > 0 && isUploaded===0">
                                    <button class="btn btn-outline-danger" (click)="resetFilesList()">{{'RESET' | translate}}</button>
                                    <button class="btn btn-primary ml-1" (click)="uploadFiles()">{{'UPLOAD_PAYROLL' | translate}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-3 border-top pt-1" *ngIf="files_list_obj.length > 0">
                            <div *ngFor="let file of files_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1 px-2">
                                <div class="flex-basis-60 d-flex align-items-center">
                                    <div class="mr-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status===0">
                                        <i [data-feather]="'x'" class="text-danger" size="18"></i>
                                    </div>
                                    <div class="mt-025">{{file.name}}</div>
                                </div>
                                <div class="flex-basis-20 text-right">
                                    <span class="badge badge-light-info" *ngIf="file.status === 0">{{'STATUS.PENDING' | translate}}</span>
                                    <span class="badge badge-light-secondary" *ngIf="file.status === 1">{{'STATUS.PROCESSING' | translate}}</span>
                                    <span class="badge badge-light-success" *ngIf="file.status === 2">{{'STATUS.COMPLETED' | translate}}</span>
                                    <span class="badge badge-light-danger" *ngIf="file.status === 3">{{'STATUS.ERROR' | translate}}</span>
                                </div>
                                <div class="flex-basis-20 text-right">{{file.size}}</div>
                            </div>
                            <div class="px-2">{{'TOTAL' | translate}}: {{files_list_obj.length}}</div>
                        </div>
                        <div class="col-12 mt-1 px-3" *ngIf="files_list_obj.length < 1">
                            <p>{{'NO_FILES_SELECTED' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="card-body" *ngIf="_utilsService.isMobile">
                    <div class="card-title text-center m-0">
                        <span>
                            {{ 'PAGE_NOT_AVAILABLE_FROM_MOBILE' | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>